import { receiptCard_master } from "./receiptcard_master";
import { receiptCard_41 } from "./receiptcard_41";
import { receiptCard_37 } from "./receiptcard_37";

let siteId: number = 12;
if (process.env.NODE_ENV === "development") {
    siteId = 41;
} else {
    const tags = document.getElementsByName("eto:site");
    siteId = tags.length === 0 ? 12 : +(tags[0] as HTMLMetaElement).content;
}
export const cardStyles = siteId === 41 ? { ...receiptCard_master, ...receiptCard_41 } :  siteId === 37 ? { ...receiptCard_master, ...receiptCard_37 } : receiptCard_master;
